var toVariable = function toVariable(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _customProperty;
    var customProperty = (_customProperty = {}, _customProperty["--" + key] = obj[key], _customProperty);
    return Object.assign({}, acc, customProperty);
  }, {});
};
var addVariablesInBody = function addVariablesInBody(cssVariables) {
  Object.keys(cssVariables).forEach(function (property) {
    document.documentElement.style.setProperty(property, cssVariables[property]);
  });
};
export default {
  addVariablesInBody: addVariablesInBody,
  toVariable: toVariable
};